export default __webpack_public_path__ + "static/Year1880-bb583f1a875e3f6ddba1c41eb1c34386.png";